import React from 'react';
import Highlight, { defaultProps } from 'prism-react-renderer';
import oceanicNext from 'prism-react-renderer/themes/github';
import PropTypes from 'prop-types';

const CodeBlock = ({ children, className = '' }) => {
    const language = className.replace(/language-/, '');

    return (
        <Highlight {...defaultProps} code={children.trim?.()} language={language || 'jsx'} theme={oceanicNext}>
            {({ className, style, tokens, getLineProps, getTokenProps }) => (
                <pre className={className} style={{ ...style, padding: '16px', fontSize: '14px' }}>
                    {tokens.map((line, i) => (
                        <div key={i} {...getLineProps({ line, key: i })}>
                            {line.map((token, key) => (
                                <span key={key} {...getTokenProps({ token, key })} />
                            ))}
                        </div>
                    ))}
                </pre>
            )}
        </Highlight>
    );
};

CodeBlock.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

export default CodeBlock;
